// @generated

import { decodeHex } from "../common/hex.js"

export default decodeHex(
"\
0061736d0100000001350860027f7f0060047f7e7f7e047f7e7f7e60047f7e7f\
7e017f60037f7f7f0060017f0060047f7f7f7f0060017f017f60027f7f017f02\
100104686f7374066d656d6f7279020001031514010200000003000003040005\
05060706070000030404017000020695022e7f0041c0010b7f0041e0010b7f00\
4180020b7f0041a0020b7f0041c0020b7f0041e0020b7f004180030b7f0041a0\
030b7f0041c0030b7f0041e0030b7f004180040b7f0041a0040b7f0041c0040b\
7f0041e0040b7f004180050b7f0041a0050b7f0041c0050b7f0041e0050b7f00\
4180060b7f0041a0060b7f0041c0060b7f0041e0060b7f004180070b7f0041a0\
070b7f0041c0070b7f0041e0070b7f004180080b7f0041a0080b7f0041c0080b\
7f0041e0080b7f004180090b7f0041a0090b7f0041c0090b7f0041e0090b7f00\
41800a0b7f0041a00a0b7f0041c00a0b7f0041e00a0b7f0041800b0b7f0041a0\
0b0b7f0041c00b0b7f0041e00b0b7f0041800c0b7f0041a00c0b7f0041c00c0b\
7f0041c5180b0789031d056669656c640300067363616c61720301096e65675f\
6669656c6403020a6e65675f7363616c617203030f753235365f6d6f645f7363\
616c617203040d6669656c645f6e65675f74776f030506726973745f64031611\
6669656c645f696e76737172745f706f770317076669656c645f6903180b6669\
656c645f6e65675f6903190d6669656c645f6e65675f6f6e65031a1572697374\
5f696e765f726f6f745f615f7375625f64031d0763757276655f61031e077269\
73745f3264032c09726973745f7a65726f032d095f753235365f61646400010c\
753235365f6d6f645f6e65670002096669656c645f61646400030a7363616c61\
725f61646400040e5f753235365f6d756c5f753531320005096669656c645f6d\
756c000608753235365f73756200080f753531325f6d6f645f7363616c617200\
090a7363616c61725f6d756c000a0d6669656c645f696e7673717274000f0b72\
6973745f6465636f646500100b726973745f656e636f64650011096375727665\
5f61646400120963757276655f706f7700130908010041000b0206120af20e14\
2b00200041046a2001200241046a2000200320003502007c200120023502007e\
7c22033e020020034220880b2200200020012002200310001000100010001000\
10001000100021031a1a1a2003a70b3100230720004120fc0a00000340230742\
012001420010010440200023074120fc0a00000c010b0b230741004120fc0b00\
0b1300200042012001420010011a2000230210020b1300200042012001420010\
011a2000230310020ba701002000200020013502002002420010013602202000\
200041046a20013502042002420010013602242000200041086a200135020820\
024200100136022820002000410c6a200135020c20024200100136022c200020\
0041106a20013502102002420010013602302000200041146a20013502142002\
420010013602342000200041186a200135021820024200100136023820002000\
411c6a200135021c20024200100136023c0b4d00230820002001100523082302\
100223092302100223084200230923084226230942001001230823021002ad42\
267e10011a230823021002200023084120fc0a00002308410041c000fc0b000b\
360020002001290300427f8537030020002001290308427f8537030820002001\
290310427f8537031020002001290318427f853703180b130020002002100720\
0042012001420110011a0b4601017f200041206a21010340200141016b220123\
0310022001200120012001310020230442001001ad230442001001ad23044200\
10011a200123031002200120004b0d000b0b2a01017f230a200020011005230b\
23031002230a10092000230a4120fc0a0000230a410041c000fc0b000b320101\
7f41808080807821040340200020002003110000200220047104402000200120\
031100000b200441017622040d000b0b2701017f2002411c6a21040340200020\
0120042802002003100b200441046b220420024f0d000b0b1d00200029030050\
2000290308507120002903105071200029031850710b31002000290300200129\
0300512000290308200129030851712000290310200129031051712000290318\
200129031851710b6c01017f231b23064120fc0a0000231b200023174100100c\
231c231b4120fc0a0000231c231c1006231c20001006231c231a100e2201231c\
2319100e720440231b231810060b231c2306100e200172231b2d000041017104\
40231b2300231b10080b2000231b4120fc0a00000bda0201027f230d41004180\
02fc0b00230d20014120fc0a0000230d4201230242001001044041010f0b2001\
2d0000410171044041020f0b230e20014120fc0a0000230e230e1006230f230e\
4120fc0a0000230e2300230e1008230e23061003230f230610032314230f4120\
fc0a0000231423141006231023164120fc0a00002310230e10062310230e1006\
2310231410032310230023101008231123104120fc0a00002311231410062311\
100d044041030f0b2311100f04400541040f0b231223114120fc0a0000231223\
0f1006231323114120fc0a0000231323121006231323101006200023154120fc\
0a000020002001100620002312100620002d0000410171044020002300200010\
080b200041206a2202230e4120fc0a0000200223131006200041c0006a230641\
20fc0a0000200041e0006a220320024120fc0a00002003200010062002100d20\
032d000041017172044041050f0b41000bcd0201037f200141206a2102200141\
c0006a2103200141e0006a2104230e20034120fc0a0000230e20021003230d20\
024120fc0a0000230d2300230d1008230d20031003230e230d1006230f200141\
20fc0a0000230f200210062311230f4120fc0a00002311231110062311230e10\
062311100f1a230e23111006230f231110062310230e4120fc0a00002310230f\
1006231020041006230d23104120fc0a0000230d20041006230d2d0000410171\
0440231220024120fc0a0000231223181006231320014120fc0a000023132318\
10062311230e4120fc0a00002311231d100605231220014120fc0a0000231320\
024120fc0a00002311230f4120fc0a00000b230d23104120fc0a0000230d2312\
1006230d2d000041017104400523132300231310080b23132003100323132311\
100623132d0000410171044023132300231310080b200023134120fc0a00000b\
b70201067f200041206a2102200041c0006a2103200041e0006a210420014120\
6a2105200141c0006a2106200141e0006a2107232720004120fc0a0000232720\
021003232b20014120fc0a0000232b200510032327232b1006232820004120fc\
0a00002328230023281008232820021003232b20014120fc0a0000232b230023\
2b1008232b200510032328232b1006232a20044120fc0a0000232a2007100623\
2a232c1006232920034120fc0a00002329200610062329232910032323232841\
20fc0a00002323230023231008232323271003232423284120fc0a0000232423\
2710032325232a4120fc0a00002325232910032326232a4120fc0a0000232623\
00232610082326232910032000232341e000fc0a0000200423234120fc0a0000\
2000232610062002232510062003232610062004232410060b17002000232d41\
8001fc0a00002000200120024101100c0b0b0f02004180030b01010041e0060b\
0102\
",
)
